import React from 'react';
import cn from 'classnames';
import { Form, Layout, Core } from 'connex-cds';
import styled from 'styled-components';
import { find } from 'lodash';
import { useCompanySetup, useVehicleSetup, useVehicleTypeSetup } from '../../../MasterDataProvider';
import Comments from '../../../ticket-details/comments/Comments';
import Attachments from '../../../ticket-details/attchments/Attachments';
import DriverInstructions from '../../../ticket-details/driver-instructions/DriverInstructions';
import DriverCommentInternal from '../../../ticket-details/driver-comment-internal/DriverCommentInternal';
import { LoadingUnloadingPoints } from '../../../ticket-details/logistical-info/loading-unloading-points/LoadingUnloadingPoints';
import { MaterialSummary } from '../../../ticket-details/logistical-info/material-summary/MaterialSummary';
import StatusTimes from '../../../ticket-details/logistical-info/StatusTimes';
import { useTicketContext } from '../../../TicketContext';
import UnloadingMethodForm from '../../../UnloadingMethodForm';
import { TicketDetailActions } from './TicketDetailActions';

const Styled = styled.div`
  & > * {
    &:not(:first-child) {
      margin-top: 10px;
    }
  }
`;

export const TicketDetailMobile = ({ activeFormsAndWaivers, isLoading, attachments = [], toggleEarlyAcceptance }) => {
  const companySetup = useCompanySetup();
  const { ticket } = useTicketContext();
  const { values } = Form.useFormContext();

  const vehicleSetup = useVehicleSetup();
  const vehicleTypeSetup = useVehicleTypeSetup();

  const vehicleTypeData = React.useMemo(() => {
    const targetVehicle = find(vehicleSetup.data, { id: ticket?.vehicleId });
    return find(vehicleTypeSetup.data, { crn: targetVehicle?.vehicleType?.vehicleTypeRef });
  }, [vehicleSetup.data, vehicleTypeSetup.data, ticket?.vehicleId]);

  const unloadingMethodEnabled = React.useMemo(() => {
    if (!companySetup?.data?.isUnloadingMethodEnabled) {
      return false;
    } else if (vehicleTypeData) {
      if (
        companySetup?.data?.isUnloadingMethodEnabled !== false &&
        vehicleTypeData?.isUnloadingMethodEnabled !== true
      ) {
        return false;
      }
    }
    return ticket?.customData?.ticketType !== 'PMP';
  }, [companySetup?.data?.isUnloadingMethodEnabled, ticket?.customData?.ticketType, vehicleTypeData]);

  return (
    <Styled className={cn('ticket-detail-mobile')}>
      <Core.Spinner spin={isLoading}>
        <MaterialSummary />
        <LoadingUnloadingPoints data={values} />
        {companySetup?.data?.isDriverCommentEnabled && (
          <Layout.Container style={{ padding: '15px' }}>
            <Comments />
          </Layout.Container>
        )}
        {unloadingMethodEnabled && (
          <Layout.Container style={{ padding: '10px', paddingBottom: '5px' }}>
            <UnloadingMethodForm />
          </Layout.Container>
        )}
        <Layout.Container style={{ padding: '10px', flex: '1' }}>
          <DriverInstructions data={values} />
          <TicketDetailActions
            activeFormsAndWaivers={activeFormsAndWaivers}
            toggleEarlyAcceptance={toggleEarlyAcceptance}
          />
        </Layout.Container>
        {companySetup?.data?.isDriverCommentEnabled && (
        <Layout.Container style={{ padding: '15px' }}>
          <DriverCommentInternal />
        </Layout.Container>
        )}
        {attachments?.length > 0 && <Attachments />}
        <StatusTimes />
      </Core.Spinner>
    </Styled>
  );
};
